import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';
import { AutomationProvider } from 'src/providers/automation/automation';
import { FolderProvider } from 'src/providers/folder/folder';
import { UserProvider } from 'src/providers/user/user';
import { AutomationsConfig } from 'src/util/automations';
import { Snackbar } from 'src/util/snackbar';
import Swal from "sweetalert2";
import { AccountProvider } from "../../../../providers/account/account";
import { HistoricProvider } from "../../../../providers/bookkeeping/historic/historic";
import * as moment from "moment";
import { ReleaseType } from "../../../../model/enum/ReleaseType";
import { ParticipantProvider } from "../../../../providers/participant/participant";
import { ConvertObjectPipe } from "../../../../util/pipes/ConvertObjectPipe";
import { AccountPageable } from "../../../../model/dto/bookkeping/AccountPageable";
import { take } from 'lodash';

@Component({
  selector: 'app-cadastro-automacao',
  templateUrl: './cadastro-automacao.component.html',
  styleUrls: ['./cadastro-automacao.component.scss']
})
export class CadastroAutomacaoComponent implements OnInit {


  protected _onDestroy = new Subject<void>();
  public loading: boolean = true;
  public panelExpanded: boolean = true;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  @Input() public existingAutomation = null;

  // STEP Action
  public actionList: any = [];
  public automationAction: any = null;
  public automationPriority: number = null;
  public maxAutomationActionsFormPerLoad: number = 10;
  public allAutomationActionFormShown: boolean = false;
  shownAutomationCount = 0;
  totalAutomationCount = 0;
  public allCompanies: any[] = [];
  customizeByCompany: boolean = false;

  // STEP General Settings (Companies and Period)
  public generalAutomationSettings = {
    companies: {
      values: [],
      selected: new FormControl(),
      companyMultiFilterCtrl: new FormControl(),
      filteredCompanyMulti: new ReplaySubject<any[]>(1),
    },
    period: {
      startDate: moment().startOf('year').toDate(),
      endDate: moment().endOf('year').toDate()
    }
  };

  // STEP General Posting DFE Settings (Account and Historic)
  public generalAutomationPostingDfeData = {
    planAccount: {
      values: [],
      selected: null,
      accountLeafPage: 0,
      leafLoaded: false,
      isSearchingAccount: false,
      accountSearchInitialized: false,
      isSelectAccountOpen: false,
      accountPlanFilterCtrl: new FormControl(),
      filter_planAccount: new ReplaySubject<any[]>(1),
    },
    historic: {
      values: [],
      selected: null,
      historicFilterCtrl: new FormControl(),
      filter_historic: new ReplaySubject<any[]>(1),
    }
  };

  // STEP Condition
  public automationConditionFormArray: any = new FormArray([]);
  public automationConditionSelectsValues = {
    participantFilterCtrl: new FormControl(),
    filter_participant: new ReplaySubject(),
    participants: [],
    participantLoaded: false,
  }

  // STEP Companies
  public automationActionValuesList: any = [];
  public automationActionFormArray: any = new FormArray([]);
  public filteredAutomationActionFormGroups: any = [];
  public formCompanies: any[] = [];
  public companyFilterCtrl: FormControl = new FormControl();
  public filtered_companies: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public bankAccountFilterCtrl: [] = [];
  public filter_bankAccount: [] = [];
  public propertyFilterCtrl: [] = [];
  public filter_property: any = [];

  public loadedCompanyData: Set<number> = new Set();
  public formGroupFilterCtrl: FormControl = new FormControl();


  //STEP 4 →  Review
  public automationGroupId: number = null;
  public automationDescription: string = "";

  constructor(
    public automationsConfig: AutomationsConfig,
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public snackBar: Snackbar,
    public fb: FormBuilder,
    public userProvider: UserProvider,
    public folderProvider: FolderProvider,
    public automationProvider: AutomationProvider,
    public planAccountProvider: AccountProvider,
    public historicProvider: HistoricProvider,
    public participantProvider: ParticipantProvider,
    public cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.actionList = this.automationsConfig.actionList();
    this.formGroupFilterCtrl.valueChanges.subscribe(() => {
      this.getFilteredFormGroups();
    });
    Promise.all([this.initializeConditionSelectValuesParticipant(), this.initializeCompanies()]).then(() => {
      if (this.existingAutomation) {
        this.existingAutomation = this.existingAutomation.filter(a => {
          const company = this.generalAutomationSettings.companies.values.find(c => c.id === a.companyId);
          return company !== undefined && company !== null;
        });
        this.existingAutomationToForm();
      }
      this.loading = false;
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  public getFilteredFormGroups() {
    const filterValue = this.formGroupFilterCtrl.value
      ? this.formGroupFilterCtrl.value.toLowerCase()
      : '';

    this.filteredAutomationActionFormGroups = this.automationActionFormArray.controls.map((formGroup: any) => {
      const company = formGroup.controls.company.value;
      const isShown = formGroup.controls.isShown.value;
      let matches = false;

      if (!filterValue) {
        matches = isShown === true;
      } else if (!company) {
        matches = 'empresa não selecionada'.includes(filterValue);
      } else {
        const companyId = company.id ? company.id.toString().toLowerCase() : '';
        const companyName = company.name ? company.name.toLowerCase() : '';
        matches = companyId.includes(filterValue) || companyName.includes(filterValue);
      }

      formGroup.controls.isFiltered.setValue(matches);
      return formGroup;
    });
  }

  getPlanAccountInfo(value) {
    this.generalAutomationPostingDfeData.planAccount.selected = value;
    if (value.historicId) {
      this.generalAutomationPostingDfeData.historic.selected = this.generalAutomationPostingDfeData.historic.values.find(h => h.id === value.historicId).id;
      this.snackBar.openLong("Histórico associado à conta carregado automaticamente.", "success");
    }
    this.loading = true;
    this.participantProvider.getAccountParticipants(this.generalAutomationPostingDfeData.planAccount.selected.id).then((participants: any) => {
      if (participants.length && !this.existingAutomation) {
        this.addAutomationConditionFormGroup();
        const formGroup = this.automationConditionFormArray.controls.at(-1);
        const conditionName = this.generalAutomationPostingDfeData.planAccount.selected.featureType === 'EXPENSE' ? 'Emitente - CPF/CNPJ' : 'Destinatário - CPF/CNPJ';
        const conditionOperator = this.generalAutomationPostingDfeData.planAccount.selected.featureType === 'EXPENSE' ? 'issuerCpfCnpjs' : 'addressedCpfCnpjs';
        const conditionValue = this.automationConditionSelectsValues.participants.filter((item) => (participants.map((participant) => participant.cpfCNPJParticipant)).includes(item.value));
        formGroup.controls.condition.setValue(this.automationAction.conditions.find(item => item.name === conditionName));
        formGroup.controls.conditionOperator.setValue(conditionOperator);
        formGroup.controls.conditionExtraValues.setValue([...conditionValue]);
        formGroup.controls.conditionValue.setValue(" ");
      }
      this.loading = false;
    }).catch(error => {
      this.loading = false;
      this.snackBar.openLong("Erro ao buscar participantes da conta selecionada", "erro");
    });
  }

  existingAutomationToForm() {

    this.checkIfAutomationIsDuplicated(this.existingAutomation);

    const automationType = this.existingAutomation[0].automationType;
    this.automationAction = this.actionList.find(action => action.action === automationType);
    this.automationGroupId = this.existingAutomation[0].groupId;
    this.automationPriority = this.existingAutomation[0].priority;
    this.automationDescription = this.existingAutomation[0].description;
    this.selectAutomationType();
    this.setExistingAutomationConditionToForm();
    this.setExistingAutomationValueToForm();
  }

  checkIfAutomationIsDuplicated(data) {
    const originals: typeof data = [];
    const repeatedItems: typeof data = [];
    const seen = new Map<number, { object: any }>();

    data.forEach(item => {
      const existing = seen.get(item.companyId);
      if (!existing) {
        seen.set(item.companyId, { object: item });
        originals.push(item);
      } else {
        if (item.id < existing.object.id) {
          repeatedItems.push(existing.object);
          seen.set(item.companyId, { object: item });
          const index = originals.findIndex(o => o.companyId === item.companyId);
          if (index !== -1) {
            originals[index] = item;
          }
        } else {
          repeatedItems.push(item);
        }
      }
    });

    console.log('Originals ', originals.sort((a, b) => a.companyId - b.companyId));
    console.log('Repeated ', repeatedItems.sort((a, b) => a.companyId - b.companyId));

    return repeatedItems.length;
  }

  setExistingAutomationConditionToForm() {
    this.automationAction.conditions.forEach(condition => {
      Object.entries(condition.operators).forEach(([operator]) => {
        if (this.existingAutomation[0][operator] !== undefined) {
          this.addAutomationConditionFormGroup();
          const formGroup = this.automationConditionFormArray.controls.at(-1);
          formGroup.controls.condition.setValue(condition);
          formGroup.controls.conditionOperator.setValue(operator);
          const conditionValue = this.existingAutomation[0][operator];
          if (Array.isArray(conditionValue)) {
            formGroup.controls.conditionExtraValues.setValue(this.setExistingAutomationConditionExtraValuesToForm(formGroup, conditionValue));
            formGroup.controls.conditionValue.setValue(" ");
          } else {
            formGroup.controls.conditionValue.setValue(conditionValue);
          }
        }
      });
    });
  }

  setExistingAutomationConditionExtraValuesToForm(formGroup, conditionValue) {
    if (formGroup.controls.condition.value.inputType.includes('select')) {
      if (formGroup.controls.condition.value.inputType.includes('participant')) {
        return this.automationConditionSelectsValues.participants.filter((item) => conditionValue.includes(item.value));
      }
    } else {
      return [...conditionValue]
    }
  }

  setExistingAutomationValueToForm() {
    this.totalAutomationCount = this.existingAutomation.length;
    this.shownAutomationCount = 0;
    this.existingAutomationActionValuesToFormGroup();
    this.setAutomationActionFormGroupsVisibility(0);
  }

  existingAutomationActionValuesToFormGroup() {
    const companyMap = new Map(this.formCompanies.map(c => [c.id, c]));
    const postingIndices: number[] = [];

    this.existingAutomation.forEach((automation) => {
      const company = companyMap.get(automation.companyId);
      if (company) {
        const formGroupConfig = this.buildFormGroupConfig(company, automation);
        const formGroup = this.fb.group(formGroupConfig);
        this.automationActionFormArray.push(formGroup);

        if (this.automationAction.action === "POSTING_DFE") {
          postingIndices.push(this.automationActionFormArray.length - 1);
        }
      }
    });


    this.getFilteredFormGroups();

    if (postingIndices.length > 0) {
      setTimeout(() => {
        postingIndices.forEach(index => this.initializePostingDataSearch(index));
      }, 0);
    }
  }

  buildFormGroupConfig(company: any, automation: any) {
    const formGroupConfig = {
      id: [automation ? automation.id : null],
      priority: [automation ? automation.priority : null],
      company: [company, Validators.required],
      startDate: [automation ? moment(automation.startDate).toDate() : moment().startOf('year')],
      endDate: [automation ? moment(automation.endDate).toDate() : moment().endOf('year')],
      isActive: [automation ? automation.isActive : true, Validators.required],
      formGroupKey: [Date.now() + Math.random()],
      isShown: automation ? false : true,
      isFiltered: false
    };

    if (this.automationAction.action === "POSTING_DFE") {
      Object.assign(formGroupConfig, {
        bankAccount: [automation ? automation.bankAccountId : null, Validators.required],
        planAccount: [null],
        property: [automation ? automation.propertyCode : null, Validators.required],
        releaseType: [null]
      });
      this.automationActionValuesList.push({ bankAccounts: [], properties: [] });
    } else if (
      this.automationAction.action === "MOVE_DFE_TO_FOLDER" ||
      this.automationAction.action === "MOVE_CANCELLED_DFE_TO_FOLDER"
    ) {
      formGroupConfig['value'] = [automation ? automation.folderId : null, Validators.required];
      this.automationActionValuesList.push(automation ? [] : null);
    }

    return formGroupConfig;
  }

  async onAutomationActionFormGroupPanelOpened(index: number) {
    const formGroup = this.automationActionFormArray.controls[index];
    const company = formGroup.controls.company.value;

    if (!company || this.loadedCompanyData.has(company.id)) {
      return;
    }

    this.loading = true;

    try {
      const action = this.automationAction.action;

      if (["MOVE_DFE_TO_FOLDER", "MOVE_CANCELLED_DFE_TO_FOLDER"].includes(action)) {
        const folders: any = await this.folderProvider.getFoldersByCompanyId(company.id);
        this.automationActionValuesList[index] = folders;
      } else if (action === "POSTING_DFE") {
        const postingData = await this.automationProvider.getPostingData(company.id);
        this.setPostingData(postingData, index);
      }
      this.loadedCompanyData.add(company.id);
    } catch (error) {
      console.error(error);
      this.snackBar.openLong(`Erro ao buscar dados da empresa ${company.name}`, "erro");
    } finally {
      this.loading = false;
    }
  }

  showMoreAutomationActionFormGroups() {
    this.setAutomationActionFormGroupsVisibility(this.shownAutomationCount);
  }

  private setAutomationActionFormGroupsVisibility(startIndex: number) {
    const endIndex = startIndex + this.maxAutomationActionsFormPerLoad;
    const itemsToLoad = this.automationActionFormArray.controls.slice(startIndex, endIndex);

    itemsToLoad.forEach(automation => {
      automation.get('isShown').setValue(true);
      this.shownAutomationCount++;
      this.getFilteredFormGroups();
    });

    this.allAutomationActionFormShown =
      this.shownAutomationCount >= this.automationActionFormArray.length;
  }

  selectAutomationType() {
    if (this.automationAction.action === "POSTING_DFE") {
      this.historicProvider.getAllHistorics().then((historics: any[]) => {
        this.generalAutomationPostingDfeData.historic.values = [{id: 0, description: 'HISTÓRICO PADRÃO FARMCONT'}, ...(historics || [])];
        this.initializeHistoricSearch();
        if (this.existingAutomation) {
          this.planAccountProvider.getAccountById(this.existingAutomation[0].planAccountId).then((account) => {
            let pipe = new ConvertObjectPipe();
            const transformedAccount = pipe.transform([account], 'categoria');
            this.generalAutomationPostingDfeData.planAccount.selected = transformedAccount[0];
            this.generalAutomationPostingDfeData.planAccount.values = [transformedAccount[0]];
            this.generalAutomationPostingDfeData.planAccount.filter_planAccount.next(this.generalAutomationPostingDfeData.planAccount.values.slice());
            this.initializeAccountPlanSearch();
          });
          this.generalAutomationPostingDfeData.historic.selected = this.existingAutomation[0].historicId;
        } else {
          this.initializeAccountPlanSearch();
        }
      }).catch((error) => {
        this.snackBar.openLong(`Erro ao buscar históricos. ${error.error.error_description}`, "erro");
      });
    }
  }

  addAutomationConditionFormGroup() {
    this.automationConditionFormArray.push(this.fb.group({
      condition: [null, Validators.required],
      conditionOperator: [null, Validators.required],
      conditionValue: [null],
      conditionExtraValues: [[]],
    }));
  }

  removeAutomationConditionFormGroup(index: number) {
    this.automationConditionFormArray.removeAt(index);
  }

  removeAllAutomationConditionFormGroup() {
    this.automationConditionFormArray.clear();
  }

  setConditionValidator(value, formGroup, index) {
    formGroup.controls.conditionValue.setValue("");
    formGroup.controls.conditionExtraValues.setValue([]);
    const isMultiple = value.inputType.includes('multiple');
    formGroup.controls.conditionExtraValues.setValidators(isMultiple ? Validators.required : null);
    formGroup.controls.conditionValue.setValidators(isMultiple ? null : Validators.required);
  }

  conditionParticipantSelect(formGroup, conditionValue) {
    const conditionExtraValues = formGroup.controls.conditionExtraValues.value;
    if (!conditionExtraValues.includes(conditionValue)) {
      conditionExtraValues.push(conditionValue);
      formGroup.controls.conditionExtraValues.setValue(conditionExtraValues);
    } else {
      this.snackBar.openLong("Valor já adicionado", "erro");
    }
    formGroup.controls.conditionValue.setValue("");
  }

  handleKeyDownConditionValue(formGroup, event: KeyboardEvent) {
    const conditionValue = formGroup.controls.conditionValue.value.trim().replace(/\D/g, "");
    if ((event.key === " " || event.key === 'Enter') && conditionValue) {
      event.preventDefault();
      const conditionExtraValues = formGroup.controls.conditionExtraValues.value;
      if (!conditionExtraValues.includes(conditionValue)) {
        conditionExtraValues.push(conditionValue);
        formGroup.controls.conditionValue.setValue("");
        formGroup.controls.conditionExtraValues.setValue(conditionExtraValues);
      } else {
        this.snackBar.openLong("Valor já adicionado", "erro");
      }
    }
  }

  handlePasteConditionValue(formGroup, event: ClipboardEvent) {
    event.preventDefault();

    const clipboard = event.clipboardData;
    if (!clipboard) return;

    const pastedText = clipboard.getData('text');
    if (!pastedText) return;

    const items = pastedText
      .split(/[;\r\n, ]+/)
      .map(item => item.trim())
      .filter(item => item);

    const conditionExtraValues = formGroup.controls.conditionExtraValues.value;
    items.forEach(item => {
      if (!conditionExtraValues.includes(item)) {
        conditionExtraValues.push(item);
      }
    });
    formGroup.controls.conditionExtraValues.setValue(conditionExtraValues);

    const inputElement = event.target as HTMLInputElement;
    if (inputElement) inputElement.value = '';
  }

  removeConditionExtraValue(formGroup, index) {
    const extraValues = formGroup.controls.conditionExtraValues.value;
    extraValues.splice(index, 1);
    if (!extraValues.length) {
      formGroup.controls.conditionExtraValues.setErrors(Validators.required);
    }
  }

  trackByFormGroupKey(index: number, formGroup: AbstractControl): any {
    return formGroup.get('formGroupKey') ? formGroup.get('formGroupKey').value : index;
  }

  addAutomationActionFormGroup(company, skipFilter = false) {
    const formGroupConfig = {
      id: [null],
      priority: [null],
      company: [company || null, Validators.required],
      startDate: [moment().startOf('year')],
      endDate: [moment().endOf('year')],
      isActive: [true, Validators.required],
      formGroupKey: [Date.now() + Math.random()],
      isShown: true,
      isFiltered: false
    };

    if (this.automationAction.action === "MOVE_DFE_TO_FOLDER" ||
      this.automationAction.action === "MOVE_CANCELLED_DFE_TO_FOLDER") {
      formGroupConfig['value'] = [null, Validators.required];
      this.automationActionValuesList.push(null);
    } else if (this.automationAction.action === "POSTING_DFE") {
      Object.assign(formGroupConfig, {
        bankAccount: [null, Validators.required],
        planAccount: [null],
        property: [null, Validators.required],
        releaseType: [null]
      });
      this.automationActionValuesList.push({ bankAccounts: [], properties: [] });
    }

    const formGroup = this.fb.group(formGroupConfig);
    this.automationActionFormArray.push(formGroup);

    if (!skipFilter) {
      this.getFilteredFormGroups();
    }
  }

  removeAutomationActionFormGroup(index: number) {
    const formGroup = this.automationActionFormArray.controls[index];
    const id = formGroup.controls.id.value;

    const removeFormGroup = () => {
      this.automationActionFormArray.removeAt(index);
      this.automationActionValuesList.splice(index, 1);
      if (this.automationAction.action === "POSTING_DFE") {
        [this.bankAccountFilterCtrl, this.filter_bankAccount,
        this.propertyFilterCtrl, this.filter_property
        ].forEach(arr => {
          if (index < arr.length) arr.splice(index, 1);
        });

        for (let i = 0; i < this.automationActionFormArray.length; i++) {
          if (this.automationActionFormArray.controls[i].get('formGroupKey')) {
            this.automationActionFormArray.controls[i].get('formGroupKey').setValue(Date.now() + Math.random());
          }

          const values = this.automationActionValuesList[i];
          this.createFilterControl(this.bankAccountFilterCtrl, this.filter_bankAccount, values.bankAccounts, i);
          this.createFilterControl(this.propertyFilterCtrl, this.filter_property, values.properties, i);
        }
      }
      setTimeout(() => this.cdRef.detectChanges());
    };

    if (id) {
      Swal.fire({
        title: 'Você tem certeza?',
        text: "Você não poderá reverter isso!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.automationProvider.deleteAutomationByAutomationId(id, formGroup.controls.company.value.id, this.automationAction.service)
            .then(() => {
              const index = this.existingAutomation.findIndex(item => item.companyId === formGroup.controls.company.value.id);
              if (index !== -1) {
                this.existingAutomation.splice(index, 1);
              }
              removeFormGroup();
              Swal.fire('Excluído!', 'A automação foi excluída.', 'success');
            })
            .catch(error => {
              this.snackBar.openLong(error.message, 'erro');
            });
        }
      });
    } else {
      removeFormGroup();
    }
  }

  removeAllAutomationActionFormGroup() {
    this.automationActionFormArray.clear();
    this.automationActionValuesList = [];
    if (this.automationAction.action === "POSTING_DFE") {
      const arraysToClear = [
        this.bankAccountFilterCtrl,
        this.filter_bankAccount,
        this.propertyFilterCtrl,
        this.filter_property
      ];
      arraysToClear.forEach(arr => arr = []);
    }
  }

  companySelectActionValue(index: number, event) {

    if ((this.existingAutomation && this.existingAutomation.find(a => a.companyId === event.id)) ||
      this.automationActionFormArray.controls.some((group, grpIndex) =>
        grpIndex !== index && group.controls.company.value && group.controls.company.value.id === event.id
      )) {
      this.snackBar.openLong("Já existe uma automação para a empresa selecionada", "erro");
      this.automationActionFormArray.controls[index].controls.company.setValue(null);
      return;
    }

    if (this.automationAction.action === "MOVE_DFE_TO_FOLDER" || this.automationAction.action === "MOVE_CANCELLED_DFE_TO_FOLDER") {
      this.loading = true;
      return this.folderProvider.getFoldersByCompanyId(this.automationActionFormArray.controls[index].controls.company.value.id)
        .then(folders => {
          this.automationActionValuesList[index] = folders;
          this.loadedCompanyData.add(event.id);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.snackBar.openLong("Erro ao buscar pastas", "erro");
        });
    } else if (this.automationAction.action === "POSTING_DFE") {
      this.loading = true;
      return this.automationProvider.getPostingData(event.id).then((result: any) => {
        this.loadedCompanyData.add(event.id);
        this.setPostingData(result, index);
      });
    }
  }

  setPostingData(value, index) {
    this.automationActionValuesList[index] = {
      bankAccounts: value.bankAccounts || [],
      accountPlans: value.accountPlans || [],
      properties: [{
        propertyCode: 'AUTOMATIC_PROPERTY',
        name: 'Imóvel com base na IE da nota'
      }, ...value.properties || []],
    };
    this.initializePostingDataSearch(index);
    this.loading = false;
  }

  async addAllActionCompanies(companiesToAdd?: any[]) {
    if (!companiesToAdd) {
      const toRemove = this.automationActionFormArray.controls
        .filter(group => group.controls.company.value)
        .map(group => group.controls.company.value.id);
      companiesToAdd = this.formCompanies.filter(company => !toRemove.includes(company.id));
    }

    if (companiesToAdd.length === 0) return;

    this.loading = true;
    const action = this.automationAction.action;

    try {
      const fetchedData = await Promise.all(companiesToAdd.map(async (company) => {
        try {
          if (["MOVE_DFE_TO_FOLDER", "MOVE_CANCELLED_DFE_TO_FOLDER"].includes(action)) {
            const folders = await this.folderProvider.getFoldersByCompanyId(company.id);
            return { company, folders };
          } else if (action === "POSTING_DFE") {
            const postingData = await this.automationProvider.getPostingData(company.id);
            return { company, postingData };
          } else {
            return { company };
          }
        } catch (err) {
          throw new Error(`Erro ao buscar dados da empresa ${company.name || company.id}`);
        }
      }));

      for (const item of fetchedData) {
        this.addAutomationActionFormGroup(item.company);
        const index = this.automationActionFormArray.controls.length - 1;
        const existing = this.existingAutomation ? this.existingAutomation.find(a => a.companyId === item.company.id) : null;
        if (item.folders) {
          this.automationActionValuesList[index] = item.folders;
        } else if (item.postingData) {
          this.setPostingData(item.postingData, index);
        }
        if (existing) {
          const formGroup = this.automationActionFormArray.at(index);
          this.applyExistingAutomationActionData(formGroup, existing, this.automationActionValuesList[index]);
        }
      }

    } catch (error) {
      console.error(error);
      this.snackBar.openLong(error.message || "Erro ao buscar dados", "erro");
    } finally {
      this.loading = false;
    }
  }

  applyExistingAutomationActionData(formGroup: FormGroup, existing: any, data: any) {
    formGroup.get('id').setValue(existing.id);
    formGroup.get('priority').setValue(existing.priority);
    formGroup.get('startDate').setValue(moment(existing.startDate).toDate());
    formGroup.get('endDate').setValue(moment(existing.endDate).toDate());
    formGroup.get('isActive').setValue(existing.isActive);

    const action = this.automationAction.action;

    if (action === "POSTING_DFE" && data) {
      const { bankAccounts, properties } = data;

      formGroup.get('bankAccount').setValue(
        bankAccounts.find(acc => acc.id === existing.bankAccountId)
      );
      formGroup.get('property').setValue(
        properties.find(prop => prop.propertyCode === existing.propertyCode)
      );

    } else if (
      ["MOVE_DFE_TO_FOLDER", "MOVE_CANCELLED_DFE_TO_FOLDER"].includes(action) &&
      data
    ) {
      formGroup.get('value').setValue(
        data.find(folder => folder.id === existing.folderId)
      );
    }
  }

  onCustomizeByCompanyChange() {
    if (!this.customizeByCompany) {
      this.removeAllAutomationActionFormGroup();
    }
  }

  updateRemainingCompaniesFromGeneral() {
    const selectedCompanies = this.generalAutomationSettings.companies.selected.value || [];
    this.formCompanies = this.allCompanies.filter(company => !selectedCompanies.includes(company));
    this.filtered_companies.next(this.formCompanies.slice());
  }

  checkConditionStepValidity() {
    return this.automationConditionFormArray.controls.length > 0 &&
      this.automationConditionFormArray.controls.every(group => group.valid);
  }

  checkValueStepValidity() {
    return !this.customizeByCompany || (this.automationActionFormArray.controls.length > 0 &&
      this.automationActionFormArray.controls.every(group => group.valid));
  }

  checkPostingFormValidity(index?) {
    return this.automationActionFormArray.controls[index].valid;
  }

  checkRevisionStepValidity() {
    return this.automationDescription.length > 3;
  }

  postAutomation() {
    this.loading = true;
    const payload = this.buildAutomationsToPost();
    this.automationProvider.postAutomation(payload, this.automationAction.service)
      .then(result => this.activeModal.close(result))
      .catch(error => this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro'))
      .finally(() => this.loading = false);
  }

  putAutomation() {
    this.loading = true;
    const payload = this.buildAutomationsToPut();
    if(payload.generalChanges === null && payload.specificChanges.length === 0){
      this.activeModal.close(false);
      return;
    }
    this.automationProvider.putGeneralAndSpecificAutomation(payload, this.automationAction.service)
      .then(result => this.activeModal.close(result))
      .catch(error => this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro'))
      .finally(() => this.loading = false);
  }

  checkIfChangedAutomationConditions() {
    if (!this.existingAutomation || this.existingAutomation.length === 0) {
      return false;
    }

    const existingConditions = this.existingAutomation[0];
    const existingOperators = Object.keys(existingConditions).filter(key => this.automationsConfig.allOperators.includes(key));
    for (const operator of existingOperators) {
      if (!this.automationConditionFormArray.controls.some((group: FormGroup) => group.controls.conditionOperator.value === operator)) {
        return true;
      }
    }


    const currentConditions = this.automationConditionFormArray.controls;

    for (let currentCondition of currentConditions) {
      const currentConditionOperator = currentCondition.controls.conditionOperator.value;
      const currentConditionExtraValues = currentCondition.controls.conditionExtraValues.value;
      const currentConditionValue = currentCondition.controls.conditionValue.value;
      const currentConditionIsSelect = currentCondition.controls.condition.value.inputType.includes('select');
      const existingValue = existingConditions[currentConditionOperator];

      if (existingValue === undefined || existingValue === null) {
        return true;
      }

      if (currentConditionIsSelect) {
        const formArray = currentConditionExtraValues.map(item => item.value);
        const existingArray = Array.isArray(existingValue) ? existingValue : [existingValue];

        if (existingArray.length !== formArray.length ||
          !existingArray.every(val => formArray.includes(val))) {
          return true;
        }
      } else {
        if (currentConditionExtraValues.length > 0) {
          const existingArray = Array.isArray(existingValue) ? existingValue : [existingValue];

          if (existingArray.length !== currentConditionExtraValues.length ||
            !existingArray.every(val => currentConditionExtraValues.includes(val))) {
            return true;
          }
        } else {
          if (existingValue !== currentConditionValue) {
            return true;
          }
        }
      }
    }
    return false;
  }

  checkIfChangedAutomationDescription(){
    if (!this.existingAutomation || this.existingAutomation.length === 0) {
      return false;
    }

    return this.existingAutomation[0].description !== this.automationDescription; 
  }

  buildAutomationConditions(): Record<string, any> {
    const conditions: Record<string, any> = {};

    this.automationConditionFormArray.controls.forEach(conditionGroup => {
      const operator = conditionGroup.controls.conditionOperator.value;
      const extraValues = conditionGroup.controls.conditionExtraValues.value;
      const conditionValue = conditionGroup.controls.conditionValue.value;
      const isSelect = conditionGroup.controls.condition.value.inputType.includes('select');

      conditions[operator] = extraValues.length > 0
        ? (isSelect ? extraValues.map(item => item.value) : extraValues)
        : conditionValue;
    });

    return conditions;
  }

  buildActionSpecificFields(group: any): Record<string, any> {
    const actionFields: Record<string, any> = {};

    switch (this.automationAction.action) {
      case "MOVE_DFE_TO_FOLDER":
      case "MOVE_CANCELLED_DFE_TO_FOLDER":
        actionFields.folderId = group.controls.value.value;
        break;

      case "POSTING_DFE":
        actionFields.bankAccountId = group.controls.bankAccount.value;
        actionFields.propertyCode = group.controls.property.value;
        actionFields.historicId = this.generalAutomationPostingDfeData.historic.selected
        actionFields.planAccountId = this.generalAutomationPostingDfeData.planAccount.selected.id;
        actionFields.releaseType = this.generalAutomationPostingDfeData.planAccount.selected.releaseType;
        break;
    }
    return actionFields;
  }

  formatDateRange(startDateValue: any, endDateValue: any) {
    const startDate = new Date(startDateValue);
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(endDateValue);
    endDate.setHours(23, 59, 59, 999);

    return {
      startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: moment(endDate).format('YYYY-MM-DDTHH:mm:ss')
    };
  }

  buildAutomationsToPost() {
    const allAutomations = [];
    const sharedConditions = this.buildAutomationConditions();

    if(this.generalAutomationSettings.companies.selected.value && this.generalAutomationSettings.companies.selected.value.length){
      allAutomations.push(this.buildGeneralAutomationToPost(sharedConditions));
    }
    if (this.customizeByCompany) {
      allAutomations.push(...this.buildSpecificAutomations(sharedConditions));
    }

    return allAutomations;
  }

  buildAutomationsToPut() {
    const automations = {
      generalChanges: null,
      specificChanges: []
    }
    const sharedConditions = this.buildAutomationConditions();

    if (this.checkIfChangedAutomationConditions() || this.checkIfChangedAutomationDescription()) {
      automations.generalChanges = this.buildGeneralAutomationToPut(sharedConditions);
    }

    automations.specificChanges.push(...this.buildSpecificAutomations(sharedConditions));

    return automations;
  }

  buildGeneralAutomationToPost(sharedConditions) {
    const { startDate, endDate } = this.formatDateRange(
      this.generalAutomationSettings.period.startDate,
      this.generalAutomationSettings.period.endDate
    );

    const generalAutomation = {
      priority: this.automationPriority,
      automationType: this.automationAction.action,
      companyId: null,
      isActive: true,
      startDate: startDate,
      endDate: endDate,
      groupId: this.automationGroupId,
      description: this.automationDescription,
      companyIds: this.generalAutomationSettings.companies.selected.value.map(c => c.id) || [],
      ...sharedConditions
    };

    const folderActions = ["MOVE_DFE_TO_FOLDER", "MOVE_CANCELLED_DFE_TO_FOLDER"];
    if (folderActions.includes(this.automationAction.action)) {
      generalAutomation['folderId'] = null;
    }

    if (this.automationAction.action === "POSTING_DFE") {
      Object.assign(generalAutomation, {
        bankAccountId: null,
        propertyCode: null,
        historicId: this.generalAutomationPostingDfeData.historic.selected,
        planAccountId: this.generalAutomationPostingDfeData.planAccount.selected.id,
        releaseType: this.generalAutomationPostingDfeData.planAccount.selected.releaseType
      });
    }

    return generalAutomation;
  }

  buildGeneralAutomationToPut(sharedConditions) {
    const generalAutomation = {
      ...sharedConditions,
      description: this.automationDescription,
      automationIds: this.automationActionFormArray.controls
        .map((group) => {
          if(!this.loadedCompanyData.has(group.controls.company.value.id))
          return group.controls.id.value
        }).filter(a => a !== undefined)
    };

    return generalAutomation;
  }

  buildSpecificAutomations(sharedConditions) {

    const automations = this.automationActionFormArray.controls
      .map((group) => {
        const companyId = group.controls.company.value.id;
        const automationId = group.controls.id.value;

        // adiciona no mapeamento se o card foi aberto (loadedCompanyData tem a companyId, pra editar precisa abrir) OU se alguma condição mudou no form 
        const shouldInclude = this.loadedCompanyData.has(companyId);

        if (!shouldInclude) {
          return undefined;
        }

        const { startDate, endDate } = this.formatDateRange(
          group.controls.startDate.value,
          group.controls.endDate.value
        );

        const automation = {
          id: automationId,
          priority: this.automationPriority,
          automationType: this.automationAction.action,
          companyId: companyId,
          isActive: group.controls.isActive.value,
          startDate,
          endDate,
          groupId: this.automationGroupId,
          description: this.automationDescription,
          ...this.buildActionSpecificFields(group),
          ...sharedConditions
        };

        return automation;
      })
      //filtra os que passaram pelo map mas não foram incluidos devido a não alteração específica ou de co
      .filter(a => a !== undefined);

    return automations;
  }

  formatConditionValueToDisplay(value, mod?) {
    switch (typeof value) {
      case "boolean":
        return value ? "Verdadeiro" : "Falso";
      case "number":
        return new Intl.NumberFormat('pt-BR', {
          ...(mod.includes('currency') ? { style: 'currency' } : {}),
          currency: 'BRL'
        }).format(value);
      case "object":
        if (Array.isArray(value)) {
          return `{${value.map(this.formatConditionValueToDisplay).join(", ou ")}}`;
        } else {
          return `${value.description} - ${value.value}`
        }
      default:
        return value;
    }
  }

  setDateAllCompanies() {
    const startDate = this.automationActionFormArray.controls[0].controls.startDate.value;
    const endDate = this.automationActionFormArray.controls[0].controls.endDate.value;
    this.automationActionFormArray.controls.forEach(group => {
      group.controls.startDate.setValue(startDate);
      group.controls.endDate.setValue(endDate);
    });
  }

  initializeCompanies() {
    return this.userProvider.getAllCompanys()
      .then((result: []) => {
        result = result.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.allCompanies = result;
        this.formCompanies = result;

        this.filtered_companies.next(result.slice());
        this.generalAutomationSettings.companies.values = result;
        this.generalAutomationSettings.companies.filteredCompanyMulti.next(result.slice());
        this.generalAutomationSettings.companies.companyMultiFilterCtrl.setValue('');

        this.setupGeneralCompanyFilter();
        this.setupCompanyFilter();

      })
      .catch((error) => {
        this.snackBar.openLong("Erro ao buscar empresas", "erro");
      });
  }

  setupGeneralCompanyFilter() {
    this.generalAutomationSettings.companies.companyMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        const search = (this.generalAutomationSettings.companies.companyMultiFilterCtrl.value || '').toLowerCase();
        const filtered = this.formCompanies.filter(company =>
          company.name.toLowerCase().includes(search) ||
          company.id.toString().includes(search)
        );
        this.generalAutomationSettings.companies.filteredCompanyMulti.next(filtered);
      });
  }

  setupCompanyFilter() {
    this.companyFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => this.filterCompanies());
  }

  selectAllCompanies() {
    if (this.generalAutomationSettings.companies.selected.value.length > 1) {
      this.generalAutomationSettings.companies.selected.setValue([])
    } else {
      this.generalAutomationSettings.companies.selected.setValue(this.formCompanies.slice())
    }
  }

  toggleSelectAll(selectAllValue: boolean) {

  }

  protected filterCompanies() {
    if (!this.formCompanies) {
      return;
    }
    let search = this.companyFilterCtrl.value;
    if (!search) {
      this.filtered_companies.next(this.formCompanies.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtered_companies.next(
      this.formCompanies.filter(company => (company.name.toLowerCase().includes(search) || company.id == search))
    );
  }

  initializeConditionSelectValuesParticipant() {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.participantProvider.getAllParticipants().then((result: any[]) => {
        const participants = result.map(item => ({
          description: item.name,
          value: item.cpfCNPJParticipant,
          id: item.id
        }))
        this.automationConditionSelectsValues.participants = participants;
        this.automationConditionSelectsValues.participantFilterCtrl.setValue('');
        this.automationConditionSelectsValues.filter_participant.next(participants.slice());
        this.automationConditionSelectsValues.participantFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            const search = this.automationConditionSelectsValues.participantFilterCtrl.value ? this.automationConditionSelectsValues.participantFilterCtrl.value.toLowerCase() : '';
            const filtered = participants.filter(value =>
              value.description.toLowerCase().includes(search) ||
              value.value.toLowerCase().includes(search)
            );
            this.automationConditionSelectsValues.filter_participant.next(filtered);
          });

        resolve(true);
      }).catch(error => {
        reject(false);
        this.snackBar.openLong("Erro ao buscar participantes", "erro");
      });
    })

  }

  initializePostingDataSearch(index) {
    this.createFilterControl(this.bankAccountFilterCtrl, this.filter_bankAccount, this.automationActionValuesList[index].bankAccounts, index);
    this.createFilterControl(this.propertyFilterCtrl, this.filter_property, this.automationActionValuesList[index].properties, index);
  }

  createFilterControl(ctrlArray, filterArray, values, index) {
    const control = new FormControl();
    ctrlArray[index] = control;
    filterArray[index] = new ReplaySubject<any[]>(1);
    filterArray[index].next(values ? values.slice() : []);
    control.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filterItems(index, ctrlArray, filterArray, values);
    });
  }


  private filterItems(index, ctrlArray, filterArray, items) {
    if (!items) return;
    let search = ctrlArray[index].value ? ctrlArray[index].value.toLowerCase() : '';
    filterArray[index].next(
      items.filter(item =>
        ['description', 'name', 'code', 'customId', 'propertyCode'].some(
          field => (item[field] ? item[field].toString().toLowerCase().includes(search) : false)
        )
      )
    );
  }

  public initializeHistoricSearch() {
    this.generalAutomationPostingDfeData.historic.historicFilterCtrl = new FormControl();
    this.generalAutomationPostingDfeData.historic.filter_historic = new ReplaySubject<any[]>(1);
    this.generalAutomationPostingDfeData.historic.filter_historic.next(this.generalAutomationPostingDfeData.historic.values.slice());

    this.generalAutomationPostingDfeData.historic.historicFilterCtrl.valueChanges
      .pipe(
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        if (!this.generalAutomationPostingDfeData.historic.values) {
          return;
        }
        let search = this.generalAutomationPostingDfeData.historic.historicFilterCtrl.value;
        if (!search) {
          this.generalAutomationPostingDfeData.historic.filter_historic.next(this.generalAutomationPostingDfeData.historic.values.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        this.generalAutomationPostingDfeData.historic.filter_historic.next(
          this.generalAutomationPostingDfeData.historic.values.filter(historic =>
            historic.description.toLowerCase().includes(search)
          )
        );
      });
  }

  initializeAccountPlanSearch() {
    if (this.generalAutomationPostingDfeData.planAccount.accountSearchInitialized) {
      return;
    }
    this.generalAutomationPostingDfeData.planAccount.accountSearchInitialized = true;

    this.generalAutomationPostingDfeData.planAccount.accountPlanFilterCtrl.valueChanges
      .pipe(
        tap(() => {
          if (this.generalAutomationPostingDfeData.planAccount.isSelectAccountOpen) {
            this.generalAutomationPostingDfeData.planAccount.isSearchingAccount = true;
          }
        }),
        debounceTime(250),
        distinctUntilChanged(),
        switchMap(searchTerm => {
          this.generalAutomationPostingDfeData.planAccount.accountLeafPage = 0;
          return this.planAccountProvider.getAllAccountsLeafsByPage(searchTerm || '', 0);
        }),
        takeUntil(this._onDestroy)
      )
      .subscribe((categorias: AccountPageable[]) => {
        this.generalAutomationPostingDfeData.planAccount.isSearchingAccount = false;
        this.generalAutomationPostingDfeData.planAccount.leafLoaded = categorias['last'];
        this.generalAutomationPostingDfeData.planAccount.accountLeafPage = 1;
        const pipe = new ConvertObjectPipe();
        const newItems = pipe.transform(categorias['content'], 'categoria');
        this.generalAutomationPostingDfeData.planAccount.values.length = 0;
        const searchTerm = (this.generalAutomationPostingDfeData.planAccount.accountPlanFilterCtrl.value || '').trim();
        if (!searchTerm && this.generalAutomationPostingDfeData.planAccount.selected) {
          this.generalAutomationPostingDfeData.planAccount.values.push(this.generalAutomationPostingDfeData.planAccount.selected);
        }
        this.generalAutomationPostingDfeData.planAccount.values.push(...newItems);
        this.generalAutomationPostingDfeData.planAccount.filter_planAccount.next(this.generalAutomationPostingDfeData.planAccount.values.slice());
      });
  }

  onSelectKeydown(event: KeyboardEvent) {
    if (this.generalAutomationPostingDfeData.planAccount.isSearchingAccount && event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onSelectOpenedChange(isOpen: boolean) {
    this.generalAutomationPostingDfeData.planAccount.isSelectAccountOpen = isOpen;
    if (isOpen) {
      this.getLeafsFirstPage();
      this.generalAutomationPostingDfeData.planAccount.isSearchingAccount = false;
    } else {
      this.generalAutomationPostingDfeData.planAccount.isSearchingAccount = false;
    }
  }

  getLeafsFirstPage() {
    this.generalAutomationPostingDfeData.planAccount.isSearchingAccount = false;
    const control = this.generalAutomationPostingDfeData.planAccount.accountPlanFilterCtrl || null;
    const currentValue = control ? control.value : '';
    if (control) {
      control.setValue(currentValue || '', { emitEvent: true });
    }
  }

  getLeafsNextBatch(isScroll: boolean) {
    const control = this.generalAutomationPostingDfeData.planAccount.accountPlanFilterCtrl || null;
    const search = control ? control.value : '';
    const pipe = new ConvertObjectPipe();
    if (search === undefined) return;

    const panels = Array.from(document.querySelectorAll('.mat-select-panel')) as HTMLElement[];
    const currentPanel = panels.length > 0 ? panels[panels.length - 1] : null;
    const previousScrollTop = currentPanel ? currentPanel.scrollTop : null;

    this.planAccountProvider.getAllAccountsLeafsByPage(search, this.generalAutomationPostingDfeData.planAccount.accountLeafPage).then((categorias: AccountPageable[]) => {
      this.generalAutomationPostingDfeData.planAccount.leafLoaded = categorias['last'];
      this.generalAutomationPostingDfeData.planAccount.accountLeafPage++;

      const newItems = pipe.transform(categorias['content'], 'categoria');
      this.generalAutomationPostingDfeData.planAccount.values.push(...newItems);
      this.generalAutomationPostingDfeData.planAccount.filter_planAccount.next(this.generalAutomationPostingDfeData.planAccount.values.slice());
      if (currentPanel && previousScrollTop !== null) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            currentPanel.scrollTop = previousScrollTop;
          });
        });
      }
    });
  }

  protected readonly
  Object = Object;
  protected readonly ReleaseType = ReleaseType;
}
